import moment from 'moment';
import { useSelector } from 'react-redux';

const StudentDetailsCard = () => {
    const { roll_number, first_name, last_name, grade_name, franchise_name, date_of_birth, gender } = useSelector((state: any) => state?.auth?.selectedStudent);

    return (
        <>
            <div className="external-event" style={{ backgroundColor: "#ffd316", position: 'relative', zIndex: 'auto', left: '0px', top: '0px', width: '15%', fontWeight: 600, cursor: 'default' }}>Student Details</div>
            <div className="card mb-2">
                <div className="card-body py-2" style={{ backgroundColor: '#f9f1cc' }}>
                    <div className="row">
                        <div className="col-sm-1"><div className="form-group mb-0"><dt>Roll No.</dt><dd className="form-control-plaintext">{roll_number ?? '---'}</dd></div></div>
                        <div className="col-sm-2"><div className="form-group mb-0"><dt>Student Name</dt><dd className="form-control-plaintext">{(first_name ?? '---') + ' ' + (last_name ?? '---')}</dd></div></div>
                        <div className="col-sm-2"><div className="form-group mb-0"><dt>DOB</dt><dd className="form-control-plaintext">{date_of_birth ? moment(date_of_birth).format('DD/MM/YYYY') : '---'}</dd></div></div>
                        <div className="col-sm-2"><div className="form-group mb-0"><dt>Gender</dt><dd className="form-control-plaintext">{gender ? gender.charAt(0).toUpperCase() + gender.slice(1) : '---'}</dd></div></div>
                        <div className="col-sm-2"><div className="form-group mb-0"><dt>Year Group</dt><dd className="form-control-plaintext">{grade_name ?? '---'}</dd></div></div>
                        <div className="col-sm-3"><div className="form-group mb-0"><dt>Franchise Name</dt><dd className="form-control-plaintext">{franchise_name ?? '---'}</dd></div></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StudentDetailsCard;
